// DEPRECATED. Use selectNoteDraft or selectReplyDraft, you scrub.
import { createSelector } from 'reselect'
import { selectGroupsById } from 'selectors/app'
import { selectIsAddingNote, selectIsReplying } from 'selectors/page'
import { memoize } from 'util/memoization'
import { emptyArr } from 'util/arrays'
import { selectReplyDraft } from './replyDrafts'
import { selectNoteDraft } from './noteDrafts'

export const selectTicketDraft = createSelector(
  selectIsAddingNote,
  selectNoteDraft,
  selectReplyDraft,
  (isAddingNote, noteDraft, replyDraft) =>
    isAddingNote ? noteDraft : replyDraft
)

// GR: I *think* we can just rename this to selectReplyDraftAssignedAgent - but
// we need to double check if mobile uses it for Notes too...
//
// Selects the assigned agents of the selected tickets
export const selectTicketDraftAssignedAgent = createSelector(
  selectTicketDraft,
  draft => draft.assignee
)

const memoizedAgentArray = memoize(agent => (agent ? [agent] : emptyArr))
export const selectTicketDraftAssignedAgents = createSelector(
  selectTicketDraftAssignedAgent,
  agent => memoizedAgentArray(agent)
)

// Selects the assigned agents of the selected tickets
export const selectTicketDraftAssignedGroup = createSelector(
  selectTicketDraft,
  selectGroupsById,
  (draft, groupsById) => {
    if (!draft.assigned_group_id) return null
    return groupsById[draft.assigned_group_id]
  }
)

export const selectTicketDraftAssignedGroups = createSelector(
  selectTicketDraftAssignedGroup,
  group => (group ? [group] : emptyArr)
)

export const selectTicketDraftAutomaticActions = createSelector(
  selectTicketDraft,
  draft => draft.automaticActions || emptyArr
)

export const selectIsComposing = createSelector(
  selectIsReplying,
  selectIsAddingNote,
  (isReplying, isAddingNote) => isReplying || isAddingNote
)
